import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import 'prop-types';
import { jsx } from '@emotion/core';
import { useFieldControlContext } from '../FieldControl/FieldControlContext.js';
import { dlsColorWarning } from '../../styles/colorsDls/dlsColorWarning.js';
import { dlsColorSuccess } from '../../styles/colorsDls/dlsColorSuccess.js';
import forms from '../../styles/forms.js';
import IconWarning from '../../svg/IconWarning.js';
import IconSuccess from '../../svg/IconSuccess.js';
import { margin1R } from '../../styles/marginStatic/margin1R.js';
import { displayBlock } from '../../styles/layout/displayBlock.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var Alert = function Alert(_ref) {
  var id = _ref.id,
      show = _ref.show,
      status = _ref.status,
      showStateIcon = _ref.showStateIcon,
      theme = _ref.theme,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["id", "show", "status", "showStateIcon", "theme", "children"]);

  // Read from FieldControlContext if existing
  var _ref2 = useFieldControlContext() || {},
      contextStatus = _ref2.contextStatus;

  var showAlert = show;
  var alertStatus = status;

  if (typeof contextStatus !== 'undefined') {
    alertStatus = contextStatus;
    showAlert = contextStatus === 'error' || contextStatus === 'success';
  }

  var iconComponent = alertStatus === 'error' ? jsx(IconWarning, {
    filled: true,
    theme: _objectSpread(_objectSpread({}, dlsColorWarning), margin1R)
  }) : jsx(IconSuccess, {
    filled: true,
    theme: _objectSpread(_objectSpread({}, dlsColorSuccess), margin1R)
  });
  var statusColor = alertStatus === 'error' ? dlsColorWarning : dlsColorSuccess; // handle spacing for FieldMessageGroup or standalone

  var styleObject = id ? _objectSpread(_objectSpread({}, forms.alertForm), statusColor) : statusColor;
  return jsx("div", {
    "aria-live": "assertive",
    role: "alert"
  }, showAlert && jsx("span", _extends({
    id: id,
    css: _objectSpread(_objectSpread(_objectSpread({}, styleObject), displayBlock), theme)
  }, otherProps), jsx("div", null, showStateIcon && iconComponent, children)));
};

Alert.defaultProps = {
  id: undefined,
  status: 'error',
  show: true,
  showStateIcon: true,
  theme: undefined,
  children: undefined
};

export default Alert;
